import { Routes } from '@angular/router';
import { formSubmitGuard } from './guards/form-submit.guard';

export const routes: Routes = [
    {
        path: 'ting-offer/:id',
        loadComponent: () => import('./pages/ting-offer/ting-offer.component').then(m => m.TingOfferComponent),
        data: { apiKey: 'ting' }
    },
    {
        path: 'ting-next',
        loadComponent: () => import('./pages/ting-next/ting-next.component').then(m => m.TingNextComponent),
        data: { Key: 'ting' },
        canActivate: [formSubmitGuard]
    },
    {
        path: 'leakbot-offer/:saasKey',
        loadComponent: () => import('./pages/leakbot-offer/leakbot-offer.component').then(m => m.LeakbotOfferComponent),
        data: { apiKey: 'bot' }
    },
    {
        path: 'leakbot-next',
        loadComponent: () => import('./pages/ting-next/ting-next.component').then(m => m.TingNextComponent),
        canActivate: [formSubmitGuard]
    },
    {
        path: 'error',
        loadComponent: () => import('./pages/error-page/error-page.component').then(m => m.ErrorPageComponent)
    },
    {
        path: '',
        redirectTo: 'ting-offer',
        pathMatch: 'full'
    },

    { path: '**', redirectTo: 'error' },
    //404 case
];